import { render, staticRenderFns } from "./ManageGroupsContainer.vue?vue&type=template&id=0605d324&scoped=true&"
import script from "./ManageGroupsContainer.vue?vue&type=script&lang=js&"
export * from "./ManageGroupsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0605d324",
  null
  
)

export default component.exports